









































































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Client} from '@/models';
import CrudAddressEdit from '@/components/Crud/Address/Edit.vue';

import storeClient from '@/stores/modules/client';

import InputPhone from '@/components/Input/Phone.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";

@Component({
	components: {
		InputPhone,
		InputCountry,
		InputZipCode,
		CrudAddressEdit,
	}
})
export default class CrudClientEdit extends AbstractEditVue<Client> {

	// DF: utiliser pour la création d'un client uniquement
	// en modification on passe par la light
	private step: number = 1;

	public constructor() {
		super(
			storeClient,
			'Client modifié',
			'Client créé',
		);
	}

	@Emit()
	private onNext() {
		if ((!this.item.address) || (this.item.address === null) )
		{
			this.item.address = this.item.name;
		}
		this.step = 2;
	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		//console.log('route client edit = ' + this.$route.name);
		if (this.$route.name === 'client-edit') {
			this.$route.meta.title = 'Modification  d\'un client';
		}
	}

}
